import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import { FormikErrors, useFormikContext } from "formik";
import React from "react";
import { Accordion, Button } from "react-bootstrap";

import { IActiveTabs, IFormITR1 } from "../../../config/interfaces";
import { useAppDispatch } from "../../../redux/Store";
import { UtilService } from "../../../services";
import FASvgIcon from "../../FASvgIcon";
import PreventEditComponent from "../../PreventEditComponent";
import SvgImage from "../../SvgImage";
import { ContextAwareToggle } from "../../accordion";
import {
	AnnualInfoStatementDetails,
	CommonDeductionsDetails,
	DeductionsOnDonationsEduHRADetails,
	OtherDeductionsDetailsForm,
	TDSImmovablePropertyDetails,
	TDSNonSalaryDetails,
	TDSOnSalaryDetails,
	TDSSelfTaxPaymentsDetails,
	TDSTaxesCollectedAtSourceDetails
} from "../../itr-filing/deduction-details";

type Props = {
	handleNaviagteTab: (tabName: IActiveTabs) => void;
	allValidationError: FormikErrors<IFormITR1>;
};
const DeductionsTab: React.FC<Props> = (props: Props) => {
	const { handleNaviagteTab, allValidationError } = props;

	const dispatch = useAppDispatch();

	const { values, errors } = useFormikContext<IFormITR1>();

	const commonDeductionsError = UtilService.GetError(
		["CommonDeductions"],
		allValidationError,
		errors
	);

	const otherDeductionsError = UtilService.GetError(
		["OtherDeductions"],
		allValidationError,
		errors
	);

	return (
		<>
			<Accordion defaultActiveKey={"deductions-0"} flush>
				<Accordion.Item
					eventKey="deductions-0"
					className={classNames(
						"border",
						"border-1",
						commonDeductionsError ? "border-danger" : "border-transparent"
					)}
				>
					<ContextAwareToggle eventKey="deductions-0">
						<div className="btn-content">
							<SvgImage
								imgId={
									commonDeductionsError ? "remaining-information" : "common-deduction-information"
								}
							/>
							<h4 className="mb-0">
								Common Deductions
								{commonDeductionsError ? (
									<small className="fw-bold text-danger">
										Please correct the errors found in Common Deductions.
									</small>
								) : null}
							</h4>
						</div>
					</ContextAwareToggle>
					<Accordion.Body>
						<hr />
						<CommonDeductionsDetails />
					</Accordion.Body>
				</Accordion.Item>

				<Accordion.Item eventKey="deductions-1">
					<ContextAwareToggle eventKey="deductions-1">
						<div className="btn-content">
							<SvgImage imgId="donation-deduction-information" />
							<h4 className="mb-0">Deductions on Donations, Education loans and HRA</h4>
						</div>
					</ContextAwareToggle>
					<Accordion.Body>
						<hr />
						<DeductionsOnDonationsEduHRADetails />
					</Accordion.Body>
				</Accordion.Item>

				<Accordion.Item
					eventKey="deductions-2"
					className={classNames(
						"border",
						"border-1",
						otherDeductionsError ? "border-danger" : "border-transparent"
					)}
				>
					<ContextAwareToggle eventKey="deductions-2">
						<div className="btn-content">
							<SvgImage
								imgId={
									otherDeductionsError ? "remaining-information" : "other-deductions-information"
								}
							/>
							<h4 className="mb-0">
								Other Deductions
								{otherDeductionsError ? (
									<small className="fw-bold text-danger">
										Please correct the errors found in Other Deductions.
									</small>
								) : null}
							</h4>
						</div>
					</ContextAwareToggle>
					<Accordion.Body>
						<hr />
						<OtherDeductionsDetailsForm />
					</Accordion.Body>
				</Accordion.Item>

				{/* <Accordion.Item eventKey="deductions-3">
					<ContextAwareToggle eventKey="deductions-3">
						<div className="btn-content">
							<SvgImage imgId="cf-losses-information" />
							<h4 className="mb-0">Carry Forward of Losses</h4>
						</div>
					</ContextAwareToggle>
					<Accordion.Body>
						<hr />
						<TDSCarryForwardLossesDetails />
					</Accordion.Body>
				</Accordion.Item> */}

				<Accordion.Item eventKey="deductions-4">
					<ContextAwareToggle eventKey="deductions-4">
						<div className="btn-content">
							<SvgImage imgId="taxes-paid-information" />
							<h4 className="mb-0">Taxes Paid, TDS and TCS</h4>
						</div>
					</ContextAwareToggle>
					<Accordion.Body>
						<hr />
						<TDSOnSalaryDetails />
						<TDSNonSalaryDetails />
						<TDSImmovablePropertyDetails />
						<TDSTaxesCollectedAtSourceDetails />
						<TDSSelfTaxPaymentsDetails />
					</Accordion.Body>
				</Accordion.Item>

				<Accordion.Item eventKey="deductions-5">
					<ContextAwareToggle eventKey="deductions-5">
						<div className="btn-content">
							<SvgImage imgId="annual-deduction-information" />
							<h4 className="mb-0">Annual Information Statement</h4>
						</div>
					</ContextAwareToggle>
					<Accordion.Body>
						<hr />
						<AnnualInfoStatementDetails />
					</Accordion.Body>
				</Accordion.Item>
			</Accordion>

			<PreventEditComponent>
				<div className="btns-wrap">
					<Button
						size="lg"
						type="button"
						variant="outline-greyDark"
						onClick={() => handleNaviagteTab("income-details")}
					>
						<FASvgIcon icon={faArrowLeft} />
						Back
					</Button>
					<Button
						size="lg"
						type="button"
						variant="primary"
						onClick={() => handleNaviagteTab("review-file")}
					>
						Proceed <FASvgIcon icon={faArrowRight} />
					</Button>
				</div>
			</PreventEditComponent>
		</>
	);
};

export default DeductionsTab;
